import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getPlannerElementSetsQuery,
  getGlobalPlannerElementSetPropertiesQuery,
  getCardPlannerElementSetDetailsQuery,
  getChecklistPlannerElementSetDetailsQuery,
  getNestedChecklistPlannerElementSetDetailsQuery,
  getCurriculumProgramGradeBasicDetailsQuery,
  getPlannerElementSetConfigQuery,
} from "./PlannerElementSetConfigurationQuery";
import {
  plannerElementSetFieldsFragment,
  plannerElementSetFieldsBasicDetailsFragment,
  plannerElementSetFragment,
} from "./PlannerElementSetConfigurationFragments";

import {
  writeOrganizationMultiLevelNodeTagsToCache,
  getOrganizationMultiLevelNodeTagsFromCache,
} from "modules/CommonGraphqlHelpers";

import update from "immutability-helper";
import { getPlannerElementSetsQueryVariables } from "./PlannerElementSetConfigurationUtils";

export const getPlannerElementSetFromCache = ({ plannerElementSetId }) => {
  try {
    return client.readFragment({
      id: `PlannerElementSet:${plannerElementSetId}`,
      fragment: plannerElementSetFragment,
    });
  } catch (e) {
    return {};
  }
};

export const getPlannerElementSetsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlannerElementSetsQuery,
      variables,
    });
    return _.get(queryData, "node", []);
  } catch (e) {
    return {};
  }
};

export const writePlannerElementSetsToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getPlannerElementSetsQuery,
      variables,
      data,
    });
  } catch (e) {}
};

export const getGlobalPlannerElementSetPropertiesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getGlobalPlannerElementSetPropertiesQuery,
      variables,
    });

    return _.get(queryData, "planner.globalPlannerElementSetConfig", []);
  } catch (e) {
    return [];
  }
};

export const getCardPlannerElementSetDetailsFromCache = variables => {
  try {
    const data = client.readQuery(
      {
        query: getCardPlannerElementSetDetailsQuery,
        variables,
      },
      true
    );
    return _.get(data, ["node"], {});
  } catch (e) {
    return {};
  }
};

export const getChecklistPlannerElementSetDetailsFromCache = variables => {
  try {
    const data = client.readQuery(
      {
        query: getChecklistPlannerElementSetDetailsQuery,
        variables,
      },
      true
    );
    return _.get(data, "node", {});
  } catch (e) {
    return {};
  }
};

export const writePlannerElementSetBasicDetailsToCache = ({ id, data }) => {
  try {
    client.writeFragment({
      id: `PlannerElementSet:${id}`,
      fragmentName: "PlannerElementSetFieldsBasicDetails",
      fragment: plannerElementSetFieldsBasicDetailsFragment,
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const writePlannerElementSetToCache = ({ id, data, variables }) => {
  try {
    client.writeFragment({
      id: `PlannerElementSet:${id}`,
      fragmentName: "PlannerElementSetFields",
      fragment: plannerElementSetFieldsFragment,
      variables,
      data,
    });
  } catch (e) {
    console.error(e);
  }
};
export const readPlannerElementSetBasicDetailsFromCache = ({ id }) => {
  try {
    const queryData = client.readFragment({
      id: `PlannerElementSet:${id}`,
      fragmentName: "PlannerElementSetFieldsBasicDetails",
      fragment: plannerElementSetFieldsBasicDetailsFragment,
    });
    return queryData;
  } catch (e) {
    return {};
  }
};

export const readPlannerElementSetFromCache = ({ id, variables }) => {
  try {
    const queryData = client.readFragment({
      id: `PlannerElementSet:${id}`,
      fragmentName: "PlannerElementSetFields",
      fragment: plannerElementSetFieldsFragment,
      variables,
    });
    return queryData;
  } catch (e) {
    return {};
  }
};

export const getNestedChecklistDetailsFromCache = variables => {
  try {
    const data = client.readQuery(
      {
        query: getNestedChecklistPlannerElementSetDetailsQuery,
        variables,
      },
      true
    );
    return _.get(data, "node", {});
  } catch (e) {
    return {};
  }
};

export const getCurriculumProgramGradeBasicDetailsFromCache = variables => {
  try {
    const data = client.readQuery(
      {
        query: getCurriculumProgramGradeBasicDetailsQuery,
        variables,
      },
      true
    );
    return _.get(data, "node", {});
  } catch (e) {
    return {};
  }
};

export const updateTagsInCache = ({ newTags, organizationId, filters }) => {
  const data = getOrganizationMultiLevelNodeTagsFromCache({
    organizationId,
    filters,
  });

  const updatedData = update(data, {
    genericTagsV2: tags => [...tags, ...newTags],
  });

  writeOrganizationMultiLevelNodeTagsToCache({
    variables: {
      organizationId,
      filters,
    },
    data: {
      node: updatedData,
    },
  });
};

export const getPlannerElementSetConfigFromCache = variables => {
  try {
    const data = client.readQuery({
      query: getPlannerElementSetConfigQuery,
      variables,
    });
    return _.get(data, "node", {});
  } catch (e) {
    return {};
  }
};

export const updatePlannerElementSetInCache = ({
  variables,
  plannerElementSet,
}) => {
  const {
    curriculumProgramId,
    curriculumNodeInterfaceType,
    locale,
  } = variables;
  const queryData = getPlannerElementSetsFromCache(
    getPlannerElementSetsQueryVariables({
      curriculumProgramId,
      curriculumNodeInterfaceType,
      locale,
    })
  );
  const plannerElementSets = _.get(queryData, "plannerElementSets", []);

  const updatedPlannerElementSets = [
    ...plannerElementSets,
    {
      ...plannerElementSet,
      label: _.get(variables, "input.name", ""),
      templateFields: [],
      isConfigured: false,
      templates: null,
    },
  ];

  const updatedData = {
    node: {
      ...queryData,
      plannerElementSets: updatedPlannerElementSets,
    },
  };

  writePlannerElementSetsToCache({
    variables: getPlannerElementSetsQueryVariables({
      curriculumProgramId,
      curriculumNodeInterfaceType,
      locale,
    }),
    data: updatedData,
  });
};
